// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".upload-modal .cropper[data-v-92b6a8e8] {\n  height: 350px;\n  background: #ddd;\n}\n.upload-modal input[type=file][data-v-92b6a8e8] {\n  display: none;\n}", ""]);
// Exports
module.exports = exports;
